import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const CloseCircleIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };

  return (
    <svg
      width={finalSize.width || "24"}
      height={finalSize.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
        fill="currentColor"
      />
      <path
        d="M9.16937 15.5801C8.97937 15.5801 8.78938 15.5101 8.63938 15.3601C8.34938 15.0701 8.34938 14.5901 8.63938 14.3001L14.2994 8.64011C14.5894 8.35011 15.0694 8.35011 15.3594 8.64011C15.6494 8.93011 15.6494 9.41011 15.3594 9.70011L9.69937 15.3601C9.55937 15.5101 9.35937 15.5801 9.16937 15.5801Z"
        fill="currentColor"
      />
      <path
        d="M14.8294 15.5801C14.6394 15.5801 14.4494 15.5101 14.2994 15.3601L8.63938 9.70011C8.34938 9.41011 8.34938 8.93011 8.63938 8.64011C8.92937 8.35011 9.40937 8.35011 9.69937 8.64011L15.3594 14.3001C15.6494 14.5901 15.6494 15.0701 15.3594 15.3601C15.2094 15.5101 15.0194 15.5801 14.8294 15.5801Z"
        fill="currentColor"
      />
    </svg>
  );
};
const CloseCircleIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={CloseCircleIconSVG}
      style={{
        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default CloseCircleIcon;
